var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCraftPrediction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_881_1374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 9.99971L10.5 -0.000488281L0.499799 9.99971L10.5 19.9999L20.5002 9.99971Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35254 9.8392L9.90741 11.4612L5.65524 6.53522L2.35254 9.8392Z",
    fill: "#FCD23E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3089 11.9384L2.44141 10.2501L7.14023 14.9489C7.14789 14.9234 7.15682 14.8978 7.16831 14.8723L7.78086 13.5285C7.78086 13.5285 8.72267 12.5956 10.3089 12.5229V11.9384Z",
    fill: "#FCD23E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6924 11.9065V12.5229C12.2774 12.5944 13.2205 13.5285 13.2205 13.5285C13.2205 13.5285 13.6276 14.4384 13.8279 14.8723C13.8407 14.8991 13.8496 14.9259 13.8573 14.9527L18.5637 10.2462L10.6924 11.9065Z",
    fill: "#FCD23E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3101 1.88232L5.92773 6.26339L10.3101 11.34V1.88232Z",
    fill: "#FCD23E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5014 16.4089C9.63238 16.4089 8.84882 16.2685 8.24902 16.0566L10.5014 18.3091L12.7539 16.0566C12.1554 16.2685 11.3718 16.4101 10.5014 16.4101V16.4089Z",
    fill: "#FCD23E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0272 6.21741L10.9014 11.4714L18.6477 9.83788L15.0272 6.21741Z",
    fill: "#FCD23E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6924 11.1179L14.7557 5.94435L10.6924 1.88232V11.1179Z",
    fill: "#FCD23E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 14.783C12.6758 14.783 14.4396 13.0192 14.4396 10.8435C14.4396 8.66777 12.6758 6.90399 10.5001 6.90399C8.32433 6.90399 6.56055 8.66777 6.56055 10.8435C6.56055 13.0192 8.32433 14.783 10.5001 14.783Z",
    fill: "#FCD23E",
    stroke: "#1D1C1C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9808 9.34662C10.8353 9.48317 10.8136 9.70267 10.9183 9.86347C10.9425 9.90048 10.9336 9.95152 10.9004 9.98215L10.6312 10.2361C10.5916 10.2731 10.5303 10.2706 10.4946 10.2323L10.2445 9.96684C10.2139 9.93493 10.1641 9.92472 10.1258 9.94897C9.96372 10.0536 9.7455 10.0319 9.60895 9.88644C9.4724 9.74095 9.46219 9.52145 9.57577 9.36576C9.60257 9.33003 9.59619 9.27898 9.56556 9.24708L9.31543 8.98164C9.27843 8.94208 9.28098 8.88082 9.31926 8.84509L10.4436 7.78332C10.552 7.68123 10.7218 7.68633 10.8239 7.79353L11.8856 8.91783C11.9226 8.95739 11.9201 9.01865 11.8818 9.05438L11.6202 9.30195C11.5883 9.33258 11.5372 9.33896 11.5015 9.31216C11.3458 9.19859 11.1263 9.20752 10.9808 9.34535V9.34662Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98269 10.3535C9.11796 10.5002 9.33619 10.5245 9.49954 10.4224C9.53782 10.3981 9.58759 10.4084 9.61694 10.4415L9.86835 10.7134C9.90408 10.7529 9.9028 10.8142 9.86324 10.8499L9.59525 11.0975C9.56207 11.1281 9.55314 11.1779 9.57611 11.2149C9.67948 11.3782 9.65395 11.5965 9.50719 11.7317C9.36043 11.867 9.14093 11.8747 8.98652 11.7585C8.95079 11.7317 8.89974 11.7368 8.86784 11.7675L8.59984 12.015C8.56028 12.0508 8.49903 12.0495 8.46329 12.0099L7.41429 10.8729C7.31347 10.7631 7.31985 10.5934 7.4296 10.4926L8.56666 9.44358C8.60622 9.40785 8.66748 9.40912 8.70321 9.44868L8.94823 9.71413C8.97886 9.74731 8.98397 9.79708 8.95717 9.83281C8.84104 9.98723 8.84869 10.2067 8.98397 10.3535H8.98269Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1478 12.2677C10.2932 12.1312 10.3162 11.9129 10.2128 11.7509C10.1886 11.7139 10.1975 11.6628 10.2307 11.6335L10.5012 11.3808C10.5408 11.3438 10.6021 11.3463 10.6378 11.3859L10.8866 11.6526C10.9173 11.6858 10.967 11.6947 11.0041 11.6705C11.1661 11.5658 11.3844 11.5901 11.5209 11.7356C11.6574 11.881 11.6664 12.1005 11.5515 12.2562C11.5247 12.292 11.5311 12.343 11.5617 12.3749L11.8106 12.6416C11.8476 12.6812 11.845 12.7424 11.8055 12.7782L10.6761 13.8348C10.5676 13.9369 10.3966 13.9306 10.2958 13.8221L9.23912 12.6927C9.20212 12.6531 9.20467 12.5919 9.24423 12.5561L9.50712 12.3098C9.5403 12.2792 9.59007 12.2728 9.6258 12.2996C9.78022 12.4145 9.99972 12.4055 10.1465 12.269L10.1478 12.2677Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0533 11.2302C11.9155 11.0848 11.6973 11.0643 11.5352 11.169C11.4982 11.1932 11.4484 11.1843 11.4165 11.1524L11.1626 10.8844C11.1256 10.8461 11.1268 10.7836 11.1664 10.7479L11.4318 10.4964C11.4637 10.4658 11.4727 10.416 11.4484 10.3778C11.3438 10.2157 11.3642 9.99747 11.5097 9.85964C11.6552 9.72182 11.8734 9.71161 12.0304 9.82519C12.0661 9.85199 12.1171 9.84561 12.149 9.81498L12.4145 9.56357C12.4528 9.52657 12.5153 9.52784 12.551 9.5674L13.6154 10.6891C13.7174 10.7976 13.7136 10.9674 13.6051 11.0694L12.4834 12.1338C12.4451 12.1708 12.3826 12.1695 12.3469 12.1299L12.0993 11.8683C12.0686 11.8364 12.0623 11.7854 12.0891 11.7496C12.2026 11.5939 12.1924 11.3744 12.0546 11.229L12.0533 11.2302Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4227 11.6131L14.9209 12.1149L15.4227 12.6167L15.9245 12.1149L15.4227 11.6131Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9549 8.80551L16.4531 9.30731L16.9549 9.80912L17.4567 9.30731L16.9549 8.80551Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7335 7.83538L14.4102 8.15875L14.7335 8.48212L15.0569 8.15875L14.7335 7.83538Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24622 3.95611L8.92285 4.27948L9.24622 4.60285L9.56959 4.27948L9.24622 3.95611Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78014 9.45228L5.10352 9.12891L4.78014 8.80554L4.45677 9.12891L4.78014 9.45228Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.743 4.97702L12.2412 5.47882L12.743 5.98062L13.2448 5.47882L12.743 4.97702Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8934 5.99795L7.3916 6.49976L7.8934 7.00156L8.39521 6.49976L7.8934 5.99795Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4689 12.489L5.9707 11.9872L5.4689 11.4854L4.9671 11.9872L5.4689 12.489Z",
    fill: "#1D1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_881_1374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraftPrediction);
export default __webpack_public_path__ + "static/media/craft-prediction.02e6e157a89389b2b8b0cac229d44c4a.svg";
export { ForwardRef as ReactComponent };